module.exports = __webpack_public_path__ + "img/google-play-badge-de.235818b9.png";